import * as types from '../mutation-types';

const state = {
  isMobile: true
}

const getters = {
  isMobile: state => state.isMobile
}

const actions = {
  setMobile ({commit}, mobile) {commit(types.IS_MOBILE, mobile)},
}

const mutations = {
  [types.IS_MOBILE] (state, mobile) {
    state.isMobile = mobile
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
